import { Descope, getSessionToken, useUser } from '@descope/react-sdk';
import { LoadingOverlay, Stack, TextInput } from '@mantine/core';
import React from 'react';
import { useDispatch } from 'react-redux';

import { useCreateOrganization } from '@portals/api/organizations';
import { signedIn } from '@portals/redux/actions/auth';

import {
  useClassificationSessionStorage,
  useSignUpWizard,
} from '../../../pages/Sign-up/wizard/wizard.hooks';
import { StepTitle } from '../common';

export function OrganizationDoesntExists() {
  const { onNext, setContextData, contextData } = useSignUpWizard();
  const dispatch = useDispatch();

  const { removeClassificationSessionStorageValue } =
    useClassificationSessionStorage();

  const createOrganization = useCreateOrganization();
  const { user } = useUser();

  const onSubmit = async () => {
    const sessionToken = getSessionToken();

    const referral = localStorage.getItem('referral');

    try {
      const auth = await createOrganization.mutateAsync({
        org: contextData.org,
        name: user.name,
        email: user.email,
        afterAuthPath: '/',
        token: sessionToken,
        referral,
      });

      dispatch(signedIn(auth));

      removeClassificationSessionStorageValue();
      onNext();
    } catch (error) {
      console.error(error);
    }
  };

  if (createOrganization.isLoading) {
    return <LoadingOverlay visible />;
  }

  return (
    <Stack spacing="lg">
      <StepTitle>Name your organization</StepTitle>

      <Stack spacing="md">
        <TextInput
          required
          label="Organization name"
          data-testid="organization-name-input"
          placeholder="e.g. Xyte"
          onChange={(e) =>
            setContextData((curr) => ({
              ...curr,
              org: e.target.value,
            }))
          }
        />

        <Descope flowId="create-org-button" onSuccess={onSubmit} />
      </Stack>
    </Stack>
  );
}
